import React from 'react'
import styled from 'styled-components'

import { useDarkModeManager } from '../../state/user/hooks'
import Logo from '../../assets/svg/logo.svg'
import LogoDark from '../../assets/svg/logo_white.svg'
// import Wordmark from '../../assets/svg/wordmark.svg'
// import WordmarkDark from '../../assets/svg/wordmark_white.svg'
import { BodyTitle } from './styleds'

const Wrapper = styled.div`
  text-align: center;
`
// const TitleText = styled.div`
//   margin: 12px 0 32px;
// `

export default function BodyHead({hideLogo}: {hideLogo?: boolean}) {
  const [isDark] = useDarkModeManager()

  return (
    <>
      <Wrapper>
        {
          !hideLogo && <div>
            <img src={isDark ? LogoDark : Logo} style={{ height: 82 }} alt="logo" />
          </div>
        }
        {/* <TitleText>
          <img src={isDark ? WordmarkDark : Wordmark} style={{ height: 40 }} alt="logo" />
        </TitleText> */}
        <BodyTitle fontSize={32} fontWeight={700} style={{marginBottom: "20px"}}>
          Earning
        </BodyTitle>
      </Wrapper>
    </>
  )
}